module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/超大广角2.906d5051.png";